 // Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "FullWidthSlider") {
    $this.FullWidthSliderActive();
  }else if($this.data('section') == "CategoryProduct") {
   $this.CategoryProductActive();
  }else if($this.data('section') == "FeaturedCategories") {
    $this.find('.featured_column4').FeaturedCategories();
  }else if($this.data('section') == "FeaturedCollection") {
   $this.FeaturedCollectionActive();
  }else if($this.data('section') == "FeaturedCollection2") {
    $this.find('.product_slick_column5').FeaturedCollection2();
  }else if($this.data('section') == "HotDealProduct") {
   $this.HotDealProductActive();
  }else if($this.data('section') == "NewArrivals") {
    $this.find('.small_product_active').NewArrivals();
  }else if($this.data('section') == "ProductWithTestimonial") {
   $this.ProductWithTestimonialActive();
  }else if($this.data('section') == "TabWithProduct") {
    $this.find('.featured_column3').TabWithProduct();
  }else if($this.data('section') == "TabWithProduct_2") {
    $this.find('.product_slick_column5').TabWithProduct_2();
  }else if($this.data('section') == "TabWithProduct_3") {
   $this.TabWithProduct_3Active();
  }else if($this.data('section') == "LatestBlog") {
   $this.LatestBlogActive();
  }else if($this.data('section') == "BrandLogo") {
    $this.find('.brand_cursole').BrandLogo();
  }else if($this.data('section') == "Instagram") {
        $this.InstagramSection();
  }else if($this.data('section') == "Testimonial") {
   $this.TestimonialActive();
  }else if($this.data('section') == "HeaderSections") {
    $this.HeaderSectionsActivation();
  }else if($this.data('section') == "CollectionPage") {
    $this.CollectionPageActivation();
  }else if($this.data('section') == "RelatedProduct") {
   $this.RelatedProductActive();
  }else if($this.data('section') == "CustomCollection") {
   $this.CustomCollectionActive();
  }else if($this.data('section') == "ProductWIthSidebar_1") {
    $this.find('.product_slick_column4').ProductWIthSidebar_1();
  }else if($this.data('section') == "ProductWIthSidebar_2") {
    $this.find('.product_slick_column4').ProductWIthSidebar_2();
  }else if($this.data('section') == "ProductWIthSidebar_3") {
    $this.find('.small_product_active').ProductWIthSidebar_3();
  }else if($this.data('section') == "ProductWIthSidebar_4") {
    $this.find('.small_product_active').ProductWIthSidebar_4();
  }else if($this.data('section') == "ProductWIthSidebar_5") {
    $this.find('.blog_column1').ProductWIthSidebar_5();
  }else if($this.data('section') == "BannerWithCollection") {
    $this.find('.product_column2').BannerWithCollection();
  }else if($this.data('section') == "CollectionThumbnail") {
    $this.find('.product_column1').CollectionThumbnail();
  }else if($this.data('section') == "SectionWithSidebar") {
    $this.SectionWithSidebar();
  }else if($this.data('section') == "SectionWithSidebar2") {
    $this.SectionWithSidebar2();
  }else{}   
}
    
    
  
       //  slider active js
$.fn.FullWidthSliderActive = function() {
  var $carousel = $('[data-owl-carousel]');
  var $OwlFullWidthSlider = $('.slider_area');

  if ($carousel.length) {
    $carousel.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlFullWidthSlider.owlCarousel();

  /*---background image---*/
  function dataBackgroundImage() {
    $('[data-bgimg]').each(function () {
      var bgImgUrl = $(this).data('bgimg');
      $(this).css({
        'background-image': 'url(' + bgImgUrl + ')', // + meaning concat
      });
    });
  }
  jQuery(document).ready(function(){
    dataBackgroundImage();
  });
}; 
    
   
          
        //  Category Product active js
$.fn.CategoryProductActive = function() {
  var $carouse2 = $('[data-owl-carousel]');

 var $OwlCategoryProduct = $('.category_column5');

  if ($carouse2.length) {
    $carouse2.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlCategoryProduct.owlCarousel();


};
    
           
    // Featured Categories active js
$.fn.FeaturedCategories = function() {
  var $FeaturedCategoriesVAR = this;
  $FeaturedCategoriesVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};

    
    
 //  Featured Collection active js
    
$.fn.FeaturedCollectionActive = function() {
  var $carouse3 = $('[data-owl-carousel]');

 var $OwlFeaturedCollection = $('.product_column5');

  if ($carouse3.length) {
    $carouse3.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlFeaturedCollection.owlCarousel();


};
    
       
           
    // Featured Categories active js
$.fn.FeaturedCollection2 = function() {
  var $FeaturedCollection2VAR = this;
  $FeaturedCollection2VAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};
 
        
    
 //  Hot Deal Product active js
    
$.fn.HotDealProductActive = function() {
  var $carouse4 = $('[data-owl-carousel]');

 var $OwlHotDealProduct = $('.product_deals_column4');

  if ($carouse4.length) {
    $carouse4.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlHotDealProduct.owlCarousel();


};
    
        
       
           
    // Featured Categories active js
$.fn.NewArrivals = function() {
  var $NewArrivals2VAR = this;
  $NewArrivals2VAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};
 
    
     //  Product With Testimonial active js
    
$.fn.ProductWithTestimonialActive = function() {
  var $carouse5 = $('[data-owl-carousel]');

 var $OwlProduct = $('.product_column4');

  if ($carouse5.length) {
    $carouse5.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlProduct.owlCarousel();
  
  
  /*---testimonial active activation---*/
    $('.testimonial_active').owlCarousel({
        autoplay: true,
        autoplayTimeout: 8000,
		loop: true,
      
        items: 1,
        dots:true,
    })
    
  


}; 
    
           
    // Tab With Product active js
$.fn.TabWithProduct = function() {
  var $TabWithProductVAR = this;
  $TabWithProductVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};
 
    
               
    // Tab With Product 2 active js
$.fn.TabWithProduct_2 = function() {
  var $TabWithProduct_2VAR = this;
  $TabWithProduct_2VAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};
 
    
    
        
     //  Tab With Product 3 active js
    
$.fn.TabWithProduct_3Active = function() {
  var $carouse6 = $('[data-owl-carousel]');

 var $OwlProduct = $('.product_column5');

  if ($carouse6.length) {
    $carouse6.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlProduct.owlCarousel();
  


}; 
    
             
    //  Latest Blog active js
$.fn.LatestBlogActive = function() {
  var $carouse7 = $('[data-owl-carousel]');

 var $OwlLatestBlog = $('.blog_column4');

  if ($carouse7.length) {
    $carouse7.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlLatestBlog.owlCarousel();


};
    
               
    //  Brand Logo active js
$.fn.BrandLogo = function() {
  var $BrandLogoVAR = this;
  $BrandLogoVAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};
    
    
     
    
    // Instgram active js
    $.fn.InstagramSection = function(){
      var activation = this.find('[data-username]'),
          activeId = activation.attr('id'),
          clientUsername = activation.attr('data-username'),
          instagramHastag = activation.attr('data-hashtag'),
          ItemsLimit = activation.attr('data-limit'),
          imageSize = activation.attr('data-size'),
          instaslider = ".instagram-carousel";

      $.instagramFeed({
        'tag': instagramHastag,
        'username': clientUsername,
        'container': "#"+activeId,
        'display_profile': false,
        'display_biography': false,
        'display_gallery': true,
        'styling': false,
        'items': ItemsLimit,
        'margin': 1,
        'image_size': imageSize
      });

 
    };

    
        //  Related Product active js
$.fn.RelatedProductActive = function() {
  var $carouse8 = $('[data-owl-carousel]');

 var $OwlRelatedProduct = $('.product_column4');

  if ($carouse8.length) {
    $carouse8.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlRelatedProduct.owlCarousel();


};

        //  Custom Collection active js
$.fn.CustomCollectionActive = function() {
  var $carousel10 = $('[data-owl-carousel]');

 var $OwlCustomCollection = $('.product_column4');

  if ($carousel10.length) {
    $carousel10.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlCustomCollection.owlCarousel();


};
    

       
           
    // Product WIth Sidebar 1 active js
$.fn.ProductWIthSidebar_1 = function() {
  var $ProductWIthSidebar_1VAR = this;
  $ProductWIthSidebar_1VAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};
 

       
           
    // Product WIth Sidebar 2 active js
$.fn.ProductWIthSidebar_2 = function() {
  var $ProductWIthSidebar_2VAR = this;
  $ProductWIthSidebar_2VAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};
 

          // Product WIth Sidebar 3 active js
$.fn.ProductWIthSidebar_3 = function() {
  var $ProductWIthSidebar_3VAR = this;
  $ProductWIthSidebar_3VAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};
 
  

          // Product WIth Sidebar 4 active js
$.fn.ProductWIthSidebar_4 = function() {
  var $ProductWIthSidebar_4VAR = this;
  $ProductWIthSidebar_4VAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};
 

  

          // Product WIth Sidebar 5 active js
$.fn.ProductWIthSidebar_5 = function() {
  var $ProductWIthSidebar_5VAR = this;
  $ProductWIthSidebar_5VAR.slick({
    adaptiveHeight: true,
    speed: 1000,prevArrow:true,
    nextArrow: true,
    prevArrow: '<button class="prev_arrow"><i class="ion-ios-arrow-left"></i></button>',
    nextArrow: '<button class="next_arrow"><i class="ion-ios-arrow-right"></i></button>',
  });
};
 
   
   
      




$.fn.HeaderSectionsActivation = function() {



    /*---stickey menu---*/
    $(window).on('scroll',function() {    
           var scroll = $(window).scrollTop();
           if (scroll < 100) {
            $(".sticky-header").removeClass("sticky");
           }else{
            $(".sticky-header").addClass("sticky");
           }
    });


    
    /*---jQuery MeanMenu---*/
    $('.mobile-menu nav').meanmenu({
        meanScreenWidth: "9901",
        meanMenuContainer: ".mobile-menu",
        onePage: true,
    });   

      
    /*---slide toggle activation---*/
   $('.mini_cart_wrapper > a').on('click', function(event){
        if($(window).width() < 991){
            $('.mini_cart').slideToggle('medium');
        }
    });
  
  
   
    /*---canvas menu activation---*/
    $('.canvas_open').on('click', function(){
        $('.Offcanvas_menu_wrapper,.off_canvars_overlay').addClass('active')
    });
    
    $('.canvas_close,.off_canvars_overlay').on('click', function(){
        $('.Offcanvas_menu_wrapper,.off_canvars_overlay').removeClass('active')
    });
    
    
    /*---Off Canvas Menu---*/
    var $offcanvasNav = $('.offcanvas_main_menu'),
        $offcanvasNavSubMenu = $offcanvasNav.find('.sub-menu');
    $offcanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i class="fa fa-angle-down"></i></span>');
    
    $offcanvasNavSubMenu.slideUp();
    
    $offcanvasNav.on('click', 'li a, li .menu-expand', function(e) {
        var $this = $(this);
        if ( ($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand')) ) {
            e.preventDefault();
            if ($this.siblings('ul:visible').length){
                $this.siblings('ul').slideUp('slow');
            }else {
                $this.closest('li').siblings('li').find('ul:visible').slideUp('slow');
                $this.siblings('ul').slideDown('slow');
            }
        }
        if( $this.is('a') || $this.is('span') || $this.attr('clas').match(/\b(menu-expand)\b/) ){
        	$this.parent().toggleClass('menu-open');
        }else if( $this.is('li') && $this.attr('class').match(/\b('menu-item-has-children')\b/) ){
        	$this.toggleClass('menu-open');
        }
    });
    
    
  
  
  $('.mega-menu-li').parent('ul').addClass('mega_menu_inner');
   $('.mega_menu_inner').parent('div').addClass('mega_menu');
   $('.mega_menu').parent('li').addClass('mega_items');
  $('.sub-menu-li').parent('ul').addClass('sub_menu');
  
  
      };





(function($) {
  "use strict";

  jQuery(document).ready(function(){


    
    // All jQuery activation code paste here

    new WOW().init();  

    /*---background image---*/
	function dataBackgroundImage() {
		$('[data-bgimg]').each(function () {
			var bgImgUrl = $(this).data('bgimg');
			$(this).css({
				'background-image': 'url(' + bgImgUrl + ')', // + meaning concat
			});
		});
    }
    
    $(window).on('load', function () {
        dataBackgroundImage();
    });
    
 


    $('.modal').on('shown.bs.modal', function (e) {
        $('.product_navactive').resize();
    })

    $('.product_navactive a').on('click',function(e){
      e.preventDefault();

      var $href = $(this).attr('href');

      $('.product_navactive a').removeClass('active');
      $(this).addClass('active');

      $('.product-details-large .tab-pane').removeClass('active show');
      $('.product-details-large '+ $href ).addClass('active show');

    })
       
    /*--- Tooltip Active---*/
    $('.action_links ul li a,.add_to_cart a,.footer_social_link ul li a').tooltip({
            animated: 'fade',
            placement: 'top',
            container: 'body'
    });
    
    
    /*---  Accordion---*/
    $(".faequently-accordion").collapse({
        accordion:true,
        open: function() {
        this.slideDown(300);
      },
      close: function() {
        this.slideUp(300);
      }		
    });	  

    /*--- counterup activation ---*/
    $('.counter_number').counterUp({
        delay: 10,
        time: 1000
    });

    /*---  ScrollUp Active ---*/
    $.scrollUp({
        scrollText: '<i class="fa fa-angle-double-up"></i>',
        easingType: 'linear',
        scrollSpeed: 900,
        animation: 'fade'
    });   
    
    /*---countdown activation---*/
		
	 $('[data-countdown]').each(function() {
		var $this = $(this), finalDate = $(this).data('countdown');
		$this.countdown(finalDate, function(event) {
		$this.html(event.strftime('<div class="countdown_area"><div class="single_countdown"><div class="countdown_number">%D</div><div class="countdown_title">days</div></div><div class="single_countdown"><div class="countdown_number">%H</div><div class="countdown_title">hours</div></div><div class="single_countdown"><div class="countdown_number">%M</div><div class="countdown_title">mins</div></div><div class="single_countdown"><div class="countdown_number">%S</div><div class="countdown_title">secs</div></div></div>'));     
               
       });
	});	
    

    /*---portfolio Isotope activation---*/
      $('.portfolio_gallery').imagesLoaded( function() {

        var $grid = $('.portfolio_gallery').isotope({
           itemSelector: '.gird_item',
            percentPosition: true,
            masonry: {
                columnWidth: '.gird_item'
            }
        });

          /*---ilter items on button click---*/
        $('.portfolio_button').on( 'click', 'button', function() {
           var filterValue = $(this).attr('data-filter');
           $grid.isotope({ filter: filterValue });
            
           $(this).siblings('.active').removeClass('active');
           $(this).addClass('active');
        });
       
    });

    
    /*---shop grid activation---*/
    $('.shop_toolbar_btn > button').on('click', function (e) {
        
		e.preventDefault();
        
        $('.shop_toolbar_btn > button').removeClass('active');
		$(this).addClass('active');
        
		var parentsDiv = $('.shop_wrapper');
		var viewMode = $(this).data('role');
        
        
		parentsDiv.removeClass('grid_3 grid_4 grid_5 grid_list').addClass(viewMode);

		if(viewMode == 'grid_3'){
			parentsDiv.children().addClass('col-lg-4 col-md-4 col-sm-6').removeClass('col-lg-3 col-cust-5 col-12');
            
		}

		if(viewMode == 'grid_4'){
			parentsDiv.children().addClass('col-lg-3 col-md-4 col-sm-6').removeClass('col-lg-4 col-cust-5 col-12');
		}
        
        if(viewMode == 'grid_list'){
			parentsDiv.children().addClass('col-12').removeClass('col-lg-3 col-lg-4 col-md-4 col-sm-6 col-cust-5');
		}
            
	});
  
   
    
    
    // Product grid color variant activation code. 
    
    $('.product-color li label').click(function(){
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product-wrapper').find('.popup_cart_image').attr({ src: variantImage }); 
      return false;
    });
    

  });
  
})(jQuery);
